import { render, staticRenderFns } from "./TimestampCell.vue?vue&type=template&id=1e93c7d0&scoped=true"
import script from "./TimestampCell.vue?vue&type=script&lang=js"
export * from "./TimestampCell.vue?vue&type=script&lang=js"
import style0 from "./TimestampCell.vue?vue&type=style&index=0&id=1e93c7d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e93c7d0",
  null
  
)

export default component.exports